//https://www.youtube.com/watch?v=u3KlatzB7GM
import {createSlice} from "@reduxjs/toolkit";

//  this showed how to create the reducer
// https://stackoverflow.com/questions/68971771/react-redux-toolkit-action-in-dispatch-returns-err-object-is-not-a-functi

// const initialState = {value: {id: 0, mcode: "", name:"", description: ""}};

export const stakeholderListSlice = createSlice({
    name: 'stakeholderListSlc',
    initialState: {value: {
            id: null,
            fileId: null,
            recordId: null,
            productId: null,
            guild: null,
            fsoId: null,
            fsoTaxId: null,
            fsoFirstName: null,
            fsoLastName: null,
            fsoSuffix: null,
            contractedPartyId: null,
            contractedPartyTaxId: null,
            contractedPartyFirstName: null,
            contractedPartyLastName: null,
            contractedPartySuffix: null,
            contractedPartyCompanyName: null,
            payeeId: null,
            payeeTaxId: null,
            payeeFirstName: null,
            payeeLastName: null,
            payeeSuffix: null,
            payeeCompanyName: null,
            jobCode: null,
            contractLength: null,
            contractDate: null,
            compensation: null,
            pensionedCompensation: null,
            scaleCompensation: null,
            overtimeCompensation: null,
            premiumOvertimeCompensation: null,
            wardrobeCompensation: null,
            allowances: null,
            penalties: null,
            workBeginDate: null,
            daysWorked: null,
            note1: null,
            note2: null,
            note3: null,
            status: null,
            createdOn: null,
            createdBy: null,
            lastModifiedOn: null,
            lastModifiedBy: null,
            taxingLocation: null,
            additFringedCompensation: null,
            advance: null,
            guildEquivalent: null,
            participant: null,
            advance2: null,
            guaranteedDays: null,
            // productName: null,
            // episodeName: null,
            // photoStartDateFrom: null,
            // photoStartDateTo: null,
            // seriesExternalId: null,
            // seriesName: null,
            // seasonExternalId: null,
            // seasonNumberFrom: null,
            // seasonNumberTo: null,
            // seasonName: null,
                    stakeholderListDrawerState: false, stakeholderListDrawerMode: null, stakeholderListGridRefresh: false
        }},
    reducers:
        // {
        //     changeStakeholderList: (state, action) => {
        //         state.value = action.payload;
        //     },
        // }
{
        changeStakeholderList: (state, action) => {
                state.value = {
                        ...state.value,  // Keep existing fields
                        ...action.payload // Merge new values
                };
        }
}
});

export const { changeStakeholderList } = stakeholderListSlice.actions;

export default  stakeholderListSlice.reducer ;

// import reducer from "../reducer";

